import React, { useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Button, TextField } from '@material-ui/core';

type ChangeCardTemplateNotesDialogProps = {
  open: boolean;
  onClose: () => void;
  notes: string;
  setNotes: (value: string) => void;
}
const ChangeCardTemplateNotesDialog: React.FC<ChangeCardTemplateNotesDialogProps> = ({open, onClose, notes, setNotes}) => {
  const [value, setValue] = useState<string>('');

  useEffect(() => {
    setValue(notes);
  }, [open])

  const updateNotes = () => {
    setNotes(value);
    onClose();
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs">
      <DialogTitle>カードテンプレートの説明文を編集します</DialogTitle>
      <DialogContent style={{ overflow: 'hidden' }}>
        <TextField variant="outlined" multiline fullWidth minRows={6} maxRows={6} label="カードテンプレート説明文"
          value={value} onChange={(ev) => setValue(ev.currentTarget.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button color='primary' onClick={onClose}>
          キャンセル
        </Button>
        <Button color='primary' onClick={updateNotes}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ChangeCardTemplateNotesDialog;
